import { render } from "./EditEmployee.vue?vue&type=template&id=bd08757e&scoped=true"
import script from "./EditEmployee.vue?vue&type=script&lang=js"
export * from "./EditEmployee.vue?vue&type=script&lang=js"

import "./EditEmployee.vue?vue&type=style&index=0&id=bd08757e&scoped=true&lang=css"

import exportComponent from "/root/hr-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd08757e"]])

export default __exports__